package com.rajen.angrejidictionary.data.remote

object ApiConfig {
    private const val BASE_URL = "https://api.angrejidictionary.com/api/v1"
    const val WORD_ENDPOINT = "$BASE_URL/items/word-of-day"
    const val CONTACT_ENDPOINT = "$BASE_URL/contact"

    // Public-facing site (not the API) — used to build shareable word page links.
    // ⚠️ Update this to your actual production domain if it differs.
    const val SITE_BASE_URL = "https://angrejidictionary.com"

    fun wordByTermEndpoint(term: String): String {
        val encoded = js("encodeURIComponent(term)") as String
        return "$BASE_URL/items/word/$encoded"
    }

    /** Partial, case-insensitive search across all dictionary items (public, no auth). */
    fun wordSearchEndpoint(term: String): String {
        val encoded = js("encodeURIComponent(term)") as String
        return "$BASE_URL/items/search?word=$encoded"
    }

    /** Builds e.g. https://angrejidictionary.com/word/Surge from "surge" or "Surge". */
    fun wordPageUrl(word: String): String {
        val display = word.trim().replaceFirstChar { it.uppercaseChar() }
        val encoded = js("encodeURIComponent(display)") as String
        return "$SITE_BASE_URL/word/$encoded"
    }

    // Admin endpoints
    const val ADMIN_LOGIN_ENDPOINT = "$BASE_URL/admin/login"
    const val ADMIN_LOGOUT_ENDPOINT = "$BASE_URL/admin/logout"
    const val ADMIN_WORDS_ENDPOINT = "$BASE_URL/admin/words"
    const val ADMIN_WORD_OF_DAY_ENDPOINT = "$BASE_URL/admin/word-of-day"
    const val ADMIN_SUGGESTIONS_ENDPOINT = "$BASE_URL/suggestions"

    // Admin — push notifications
    const val ADMIN_BROADCAST_ENDPOINT = "$BASE_URL/admin/notifications/broadcast"
}
